var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEducation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#616161;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36,18c0,9.9-8.1,18-18,18C8,36,0,27.9,0,18C0,8.1,8.1,0,18,0C27.9,0,36,8.1,36,18L36,18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19.1,21.8c-0.3,0.2-0.7,0.3-1.2,0.3c-0.4,0-0.8-0.1-1.2-0.3l-5.2-3.2c0,0-0.5-0.3-0.5,0.4v3.2 c0,1.7,3.1,3.5,6.9,3.5s6.9-1.8,6.9-3.5v-3.4c0-0.5-0.3-0.3-0.3-0.3L19.1,21.8L19.1,21.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.7,16.1c0.4-0.2,0.4-0.7,0-0.9l-8-4c-0.4-0.2-1.1-0.2-1.5,0l-8,4c-0.4,0.2-0.4,0.7,0,0.9l8,4.9 c0.4,0.2,1.1,0.2,1.5,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.4,23.3v-5.4c0,0,0-0.3-0.1-0.2c-0.1,0.1-0.4,0.2-0.5,0.3c-0.1,0.1-0.1,0.3-0.1,0.3v4.9 c0,0.1-0.1,0.1-0.1,0.1c-0.3,0.2-0.5,0.5-0.5,0.8c0,0.5,0.4,0.9,0.9,0.9c0.5,0,0.9-0.4,0.9-0.9c0-0.3-0.2-0.6-0.5-0.8 C26.4,23.4,26.3,23.4,26.4,23.3L26.4,23.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducation);
export default __webpack_public_path__ + "static/media/education.aa33cf3dda6a24452e2aab05ac35b308.svg";
export { ForwardRef as ReactComponent };